import ErrorIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {Box} from '@mui/material';
import {t} from 'i18next';
import React, {useEffect} from 'react';
import {ReactComponent as CloseToast} from '../../../../src/assets/images/close-toast.svg';
import {MAX_STATUS_ICONS, ToastType} from '../../../shared/constants';
import {GAToastTrackingInfo} from '../../../types/analyticsTypes';
import ArrToast from '../arr-toast/ArrToast';
import './ArrToastNotification.scss';

export interface ArrStatusToastProps {
  title?: string;
  message: string;
  onClose: (id?: string, message?: string) => void;
  status?: ToastType[];
  setErrorIconAsAlert?: boolean;
  closeButtonAriaLabel?: string;
  gaTrackingInfo?: GAToastTrackingInfo;
}

const ArrToastNotification: React.FC<ArrStatusToastProps> = ({
  message,
  onClose,
  status = [],
  setErrorIconAsAlert,
  title,
  closeButtonAriaLabel,
  gaTrackingInfo,
}) => {
  useEffect(() => {
    if (status.length > MAX_STATUS_ICONS) {
      onClose();
    }
  }, [status, onClose]);
  const lastToastType = status[status.length - 1];

  const toastMessages = {
    [ToastType.Success]: 'common.success',
    [ToastType.Warning]: 'common.warning',
    [ToastType.Error]: 'common.error',
  };

  const renderStatus = () =>
    status.map((type, index) => {
      const errorIcon = setErrorIconAsAlert ? ErrorOutlineIcon : ErrorIcon;
      const Icon = type === ToastType.Success ? DoneIcon : errorIcon;
      return (
        <Box key={index} className={`icon ${type}`}>
          <Icon
            className={`status-icon ${type} ${setErrorIconAsAlert ? 'info' : ''}`}
          />
        </Box>
      );
    });
  return (
    <Box
      className="toast-notification__container"
      role="status"
      aria-live="polite"
    >
      {status.length > 0 && <Box className="status-row">{renderStatus()}</Box>}

      <ArrToast
        id="status-toast"
        title={title ?? t(toastMessages[lastToastType] || 'common.error')}
        type={lastToastType}
        message={message}
        duration={10000}
        dismissable
        onClose={onClose}
        closeIcon={<CloseToast />}
        position="bottom-right"
        className="activation-toast"
        closeButtonAriaLabel={closeButtonAriaLabel}
        gaTrackingInfo={gaTrackingInfo}
      />
    </Box>
  );
};

export default ArrToastNotification;
